/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Translation_Import_Button_Group_LabelInputs */



/**
* | output |
* | --- |
* | "Button group with nested dropdown" |
*
* @param {Ai_Translation_Import_Button_Group_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ai_translation_import_button_group_label = /** @type {((inputs?: Ai_Translation_Import_Button_Group_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Translation_Import_Button_Group_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe de boutons avec menu deroulant imbrique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schaltflächengruppe mit verschachteltem Dropdown-Menü")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di pulsanti con menu a discesa annidato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа кнопок с вложенным выпадающим списком")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de botones con menú desplegable anidado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("带有嵌套下拉菜单的按钮组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ネストされたドロップダウンを持つボタングループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नेस्टेड ड्रॉपडाउन के साथ बटन समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de botões com lista suspensa aninhada")
	return /** @type {LocalizedString} */ ("Button group with nested dropdown")
});